import styles from './Avatar.module.css';
import React from 'react';
import { iconsSources } from '../../helpers/icons';
import hum from '../../assets/images/channel-none.png';

export const Avatar = React.memo(({ message }) => {
  const errorHandle = (e) => {
    e.target.src = iconsSources[message.channel] || hum;
  };

  return (
    <div className={styles.avatar}>
      <img
        src={
          (message.image && message.image !== '1' && message.image) ||
          iconsSources[message.channel] ||
          hum
        }
        alt={'Avatar'}
        onError={errorHandle}
      />
    </div>
  );
});
